/* DOWB — animated <details> (source: Impulse collapsibles).
   Open: height 0→auto .35s + opacity 1s, inner translateY(40px→0) .5s. Close: height→0 .3s + opacity .3s.
   Applies to: FAQ, PDP tabs, footer accordions (mobile) and the mobile menu drawer (accordion mode). */
(function () {
  var SEL = '.cj-faq details, .product__accordion details, .cj-footer__details, header-drawer .menu-drawer__navigation details';
  var EASE = 'cubic-bezier(.25,.46,.45,.94)';
  function panelOf(d) { var s = d.querySelector(':scope > summary'); return s ? s.nextElementSibling : null; }
  function finish(d, p, inner, closing) {
    p.style.height = ''; p.style.overflow = ''; p.style.transition = ''; p.style.opacity = ''; p.style.boxSizing = '';
    if (inner) { inner.style.transform = ''; inner.style.transition = ''; }
    if (closing) d.removeAttribute('open');
    delete d.dataset.cjAnimating;
    var s = d.querySelector(':scope > summary'); if (s) s.setAttribute('aria-expanded', closing ? 'false' : 'true');
  }
  function openIt(d) {
    var p = panelOf(d); if (!p) { d.setAttribute('open', ''); return; }
    d.dataset.cjAnimating = '1'; d.setAttribute('open', '');
    var inner = p.firstElementChild;
    p.style.boxSizing = 'border-box'; p.style.overflow = 'hidden'; p.style.transition = 'none'; p.style.height = 'auto';
    var h = p.getBoundingClientRect().height;
    p.style.height = '0px'; p.style.opacity = '0';
    if (inner) { inner.style.transition = 'none'; inner.style.transform = 'translateY(40px)'; }
    p.getBoundingClientRect();
    p.style.transition = 'height .35s ' + EASE + ', opacity 1s ' + EASE;
    p.style.height = h + 'px'; p.style.opacity = '1';
    if (inner) { inner.style.transition = 'transform .5s ' + EASE; inner.style.transform = 'translateY(0)'; }
    var done = function (e) { if (e && e.target !== p) return; if (e && e.propertyName !== 'height') return; p.removeEventListener('transitionend', done); finish(d, p, inner, false); };
    p.addEventListener('transitionend', done); setTimeout(function () { if (d.dataset.cjAnimating) done(); }, 700);
  }
  function closeIt(d) {
    var p = panelOf(d); if (!p) { d.removeAttribute('open'); return; }
    d.dataset.cjAnimating = '1';
    var inner = p.firstElementChild;
    var h = p.getBoundingClientRect().height;
    p.style.boxSizing = 'border-box'; p.style.overflow = 'hidden'; p.style.transition = 'none'; p.style.height = h + 'px';
    p.getBoundingClientRect();
    p.style.transition = 'height .3s ' + EASE + ', opacity .3s ' + EASE;
    p.style.height = '0px'; p.style.opacity = '0';
    var done = function (e) { if (e && e.target !== p) return; if (e && e.propertyName !== 'height') return; p.removeEventListener('transitionend', done); finish(d, p, inner, true); };
    p.addEventListener('transitionend', done); setTimeout(function () { if (d.dataset.cjAnimating) done(); }, 600);
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest('summary'); if (!s) return;
    var d = s.parentElement; if (!d || !d.matches(SEL)) return;
    if (d.classList.contains('cj-footer__details') && window.matchMedia('(min-width: 769px)').matches) return;
    if (d.closest('header-drawer') && window.matchMedia('(min-width: 990px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (d.dataset.cjAnimating) return;
    if (d.hasAttribute('open')) closeIt(d); else openIt(d);
  }, true);
})();
